import React, { useState, useLayoutEffect, useEffect } from "react";
import PropTypes from "prop-types";
import VisitHistory from "./VisitHistory";
import Bookmark from "./Bookmark";
import { CSSTransition } from "react-transition-group";
import AlertLog from "./AlertLog";
import {
    getBookmark,
    clearBookmark
} from "../../redux-store/action/activities";
import { connect } from "react-redux";

const SideCol = ({
    toggled,
    onClose,
    getBookmark,
    clearBookmark,
    bookmarkData
}) => {
    //	Local state hold data use locally
    //	visits is an array type will hold activity history of user
    const [state, setState] = useState({
        visits: [],
        bookmarks: []
    });

    const { visits, bookmarks } = state;
    const initComponent = async() => {
        await getBookmark();
    };

    useEffect(() => {
        initComponent();
    }, []);

    useLayoutEffect(() => {
    //  Get history from localStorage on load or refresh when toggled sidebar
        const history = localStorage.getItem("act") || [];
        // const bookmarks = localStorage.getItem("bookmarks") || [];
        const bookmarks = bookmarkData || [];
        //  Up state with new history, run JSON.parse if history is a String
        setState({
            ...state,
            visits: Array.isArray(history) ? history : JSON.parse(history),
            bookmarks: bookmarks
            // bookmarks: Array.isArray(bookmarks)
            //     ? bookmarks
            //     : JSON.parse(bookmarks)
        });
    }, [toggled]);
    const clearHistory = () => {
        localStorage.setItem("act", "[]");
        setState({
            ...state,
            visits: []
        });
    };
    const handleClearBookmark = async() => {
        await clearBookmark();
        // localStorage.setItem("bookmarks", "[]");
        setState({
            ...state,
            bookmarks: []
        });
    };

    return (
        <CSSTransition
            in={toggled}
            timeout={300}
            unmountOnExit
            classNames="my-side-col"
        >
            <div
                style={{
                    position: "fixed",
                    right: 0,
                    top: "3rem"
                }}
                tabIndex="-1"
                // className="border-right"
                id="sidebar-wrapper"
            >
                <div className="sidebar-heading text-light">
                    Navigation{" "}
                    <span
                        onClick={onClose}
                        style={{ cursor: "pointer" }}
                        className={"text-white float-right"}
                    >
                        x
                    </span>
                </div>
                <div className="list list-group list-group-flush">
                    <div className="list-group-item list-group-item-action text-light bg-dark">
                        <VisitHistory
                            clearHistory={clearHistory}
                            key={"VisitHistory"}
                            visits={visits}
                        />
                        <Bookmark
                            clearBookmark={handleClearBookmark}
                            key={"Bookmark"}
                            bookmarks={bookmarks}
                        />
                        <AlertLog key={"AlertLogs"} alertLogs={[]} />
                    </div>
                </div>
            </div>
        </CSSTransition>
    );
};

const mapStateToProps = state => ({ bookmarkData: state.activities.bookmarkData });

SideCol.propTypes = {
    getBookmark: PropTypes.func,
    clearBookmark: PropTypes.func,
    toggled: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};

export default connect(mapStateToProps, {
    getBookmark,
    clearBookmark
})(SideCol);